import { Injectable, OnInit, OnDestroy } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { CookieService } from 'ngx-cookie-service';
import { Login, LoginModel } from './headerandnavigation/login/login';
import { AppCommonService } from './appcommon.service';
import { IAuthToken } from './auth.token';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';
import { ApiEndPoints } from './api.endpoints';
import { IAccount } from './headerandnavigation/accounts/account';
import { ILoggedUser, LoggedUserModel } from './headerandnavigation/loggeduser/loggeduser';

import { Subscription } from 'rxjs/Subscription';

import { OidcSecurityService, OpenIDImplicitFlowConfiguration, OidcConfigService } from 'angular-auth-oidc-client';
import { ConfigurationService } from './configuration/configuration.service';
import { IdentityUser } from './users/user';
import { LoaderService } from './LoaderService';
import { HeaderAndNavigationService } from './headerandnavigation/headerandnavigation.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthService {
  mftAccessToken: string = "mftAccessToken";
  mftAccessAccounts: string = "mftAccessAccounts";
  mftUserRoles: string = "mftUserRoles";
  mftUser: string = "mftUser";
  mftWelcomeMessageFlag: string = "mftWelcomeMessageFlag";
  mftForceChangePasswordFlag: string = "mftForceChangePasswordFlag";
  mftImpersonationId: string = "mftImpersonationId";

  showLoader: boolean;
  isAuthorized: boolean;
  identityUser: IdentityUser;
  clientId: string;

  constructor(
    private http: Http,
    private cookieService: CookieService,
    private appCommonService: AppCommonService,
    public oidcSecurityService: OidcSecurityService,
    private oidcConfigService: OidcConfigService,
    //public configurationService: ConfigurationService,
    private loaderService: LoaderService,
  ) {
    //const openIdImplicitFlowConfiguration = new OpenIDImplicitFlowConfiguration();
    //openIdImplicitFlowConfiguration.stsServer = configurationService.configuration.stsServer;
    //openIdImplicitFlowConfiguration.redirect_url = configurationService.configuration.redirect_url;
    //openIdImplicitFlowConfiguration.client_id = configurationService.configuration.client_id;
    //openIdImplicitFlowConfiguration.response_type = configurationService.configuration.response_type;
    //openIdImplicitFlowConfiguration.scope = configurationService.configuration.scope;
    //openIdImplicitFlowConfiguration.post_logout_redirect_uri = configurationService.configuration.post_logout_redirect_uri;
    //openIdImplicitFlowConfiguration.forbidden_route = configurationService.configuration.forbidden_route;
    //openIdImplicitFlowConfiguration.unauthorized_route = configurationService.configuration.unauthorized_route;
    //openIdImplicitFlowConfiguration.auto_userinfo = configurationService.configuration.auto_userinfo;
    //openIdImplicitFlowConfiguration.log_console_warning_active = configurationService.configuration.log_console_warning_active;
    //openIdImplicitFlowConfiguration.log_console_debug_active = configurationService.configuration.log_console_debug_active;
    //openIdImplicitFlowConfiguration.max_id_token_iat_offset_allowed_in_seconds = configurationService.configuration.max_id_token_iat_offset_allowed_in_seconds;
    //openIdImplicitFlowConfiguration.silent_renew = configurationService.configuration.silent_renew;
    //openIdImplicitFlowConfiguration.silent_renew_offset_in_seconds = configurationService.configuration.silent_renew_offset_in_seconds;
    //openIdImplicitFlowConfiguration.silent_renew_url = configurationService.configuration.silent_renew_url;    
    //this.oidcSecurityService.setupModule(openIdImplicitFlowConfiguration);
  }

  obtainAccessToken(login: Login): Observable<any> {
    //debugger
    if (ApiEndPoints.UseDirectEndPoint) {
      let params = new URLSearchParams();
      params.append('username', login.username);
      params.append('password', login.password);
      params.append('impersonation_id', login.impersonation_id);
      params.append('grant_type', 'password');
      let headers = new Headers({ 'Content-type': 'application/x-www-form-urlencoded; charset=utf-8' });
      let options = new RequestOptions({ headers: headers });

      return this.http.post(ApiEndPoints.OAuthEndPoint, params.toString(), options)
        .map(this.extractData)
        //.do(data => this.saveToken(data))
        .catch(this.handleError);
    }
    else {
      let loginModel = new LoginModel();
      loginModel.grant_type = 'password';
      loginModel.username = login.username;
      loginModel.password = login.password;
      loginModel.impersonation_id = login.impersonation_id;
      loginModel.EndPointURL = ApiEndPoints.OAuthEndPoint;

      let body = JSON.stringify(loginModel);
      let callURL = ApiEndPoints.BaseURL + ApiEndPoints.OAuthEndPointServer;
      //let headers: Headers = new Headers({
      //    'Content-Type': 'application/json; charset=utf-8'
      //});
      let options = new RequestOptions({ headers: this.GetHeader() });
      return this.http.post(callURL, body, options)
        .map(this.extractData)
        //.do(data => this.saveToken(data))
        .catch(this.handleError);
    }
  }

  //obtainAccessToken(login: Login): Promise<any> {
  //  if (ApiEndPoints.UseDirectEndPoint) {
  //    let params = new URLSearchParams();
  //    params.append('username', login.username);
  //    params.append('password', login.password);
  //    params.append('impersonation_id', login.impersonation_id);
  //    params.append('grant_type', 'password');
  //    let headers = new Headers({ 'Content-type': 'application/x-www-form-urlencoded; charset=utf-8' });
  //    let options = new RequestOptions({ headers: headers });

  //    return this.http.post(ApiEndPoints.OAuthEndPoint, params.toString(), options)
  //      .toPromise()
  //      .then(this.extractDataAuth)        
  //      .catch(this.handleError);
  //  }
  //  else {
  //    let loginModel = new LoginModel();
  //    loginModel.grant_type = 'password';
  //    loginModel.username = login.username;
  //    loginModel.password = login.password;
  //    loginModel.impersonation_id = login.impersonation_id;
  //    loginModel.EndPointURL = ApiEndPoints.OAuthEndPoint;

  //    let body = JSON.stringify(loginModel);
  //    let callURL = ApiEndPoints.BaseURL + ApiEndPoints.OAuthEndPointServer;
  //    let headers: Headers = new Headers({
  //      'Content-Type': 'application/json; charset=utf-8'
  //    });
  //    let options = new RequestOptions({ headers: headers });
  //    return this.http.post(callURL, body, options)
  //      .toPromise()
  //      .then(this.extractDataAuth)        
  //      .catch(this.handleError);
  //  }
  //}

  saveToken(token) {
    var expireDate = new Date().getTime() + (2000 * token.expires_in);
    //debugger
    this.cookieService.set(this.mftAccessToken, JSON.stringify(token), expireDate);
  }

  checkAuthorization(): boolean {
    //debugger;
    if (!this.cookieService.check(this.mftAccessToken)) {
      return false;
    }
    else {
      return true;
    }
  }

  //checkShowWelcomeMessage(): boolean {
  //  if (this.cookieService.check(this.mftWelcomeMessageFlag)) {
  //    return false;
  //  }
  //  else {
  //    return true;
  //  }
  //}

  //setShowWelcomeMessage() {
  //  var expireDate = new Date().getTime() + (1000 * 86400 * 365);
  //  debugger;
  //  this.cookieService.set(this.mftWelcomeMessageFlag, JSON.stringify(this.mftWelcomeMessageFlag), expireDate);
  //}

  checkShowWelcomeMessage(): boolean {
    var show: boolean = true;
    if (localStorage.getItem(this.mftWelcomeMessageFlag) != null) {
      show = false;
    }
    return show;
  }

  setShowWelcomeMessage(): void {
    localStorage.setItem(this.mftWelcomeMessageFlag, JSON.stringify(this.mftWelcomeMessageFlag));
  }

  checkShowChangePasswordMessage(): boolean {
    var show: boolean = true;
    if (localStorage.getItem(this.mftForceChangePasswordFlag) != null) {
      show = false;
    }
    return show;
  }

  setShowChangePasswordMessage(): void {
    localStorage.setItem(this.mftForceChangePasswordFlag, JSON.stringify(this.mftForceChangePasswordFlag));
  }

  isLoggedIn(): boolean {
    if (this.cookieService.check(this.mftAccessToken)) {
      return true;
    }
    else {

      return false;
    }
  }

  removeAuthorization() {
    //this.className = "loggedout";
    this.cookieService.delete(this.mftAccessToken);
    //this.cookieService.deleteAll();
    //localStorage.clear();
    localStorage.removeItem(this.mftAccessAccounts);
    localStorage.removeItem(this.mftUserRoles);
    localStorage.removeItem("mftAccessTokenLocalstorage");
    localStorage.removeItem(this.mftForceChangePasswordFlag);
  }

  getToken(): IAuthToken {
    if (this.cookieService.check(this.mftAccessToken)) {
      var token: IAuthToken = <IAuthToken>JSON.parse(this.cookieService.get(this.mftAccessToken));
    
      if (token != null || token != undefined || token.companyId != null || token.companyId != undefined) {
        token = <IAuthToken>JSON.parse(localStorage.getItem("mftAccessTokenLocalstorage"));
      }
      return token;
    }
  }

  public GetAuthHeader(): Headers {
    let token = this.getToken();
    let headers: Headers = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token.access_token}`
    });
    //let headers = new Headers({'Authorization': token.token_type + " "+ token.access_token});
    return headers;
  }

  public GetAuthHeaderNew(): Headers {
    let token = this.getToken();
    let headers: Headers = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token.access_token}`,
      'ImpersonationId': localStorage.getItem(this.mftImpersonationId)
    });
    //let headers = new Headers({'Authorization': token.token_type + " "+ token.access_token});
    return headers;
  }

  public GetHeader(): Headers {
    let token = this.getToken();
    let headers: Headers = new Headers({
      'Content-Type': 'application/json; charset=utf-8',
      'ImpersonationId': localStorage.getItem(this.mftImpersonationId)
    });
    return headers;
  }

  public GetHeaderDocument(): Headers {
    let token = this.getToken();
    let headers: Headers = new Headers({
      'Content-Type': 'application/x-www-form-urlencoded;',
      'ImpersonationId': localStorage.getItem(this.mftImpersonationId)
    });
    return headers;
  }

  private extractData(response: Response) {
    let data = response.json();
    return data || {};
  }

  private extractDataAuth(response: Response) {
    let data = response.json();
    return data || {};
  }

  private handleError(error: Response): Observable<any> {
    return Observable.throw((error.json().error) ? 'Username or Password is incorrect' : 'Server error');
  }

  setAccessAccounts(accounts: IAccount[]): void {
    //this.cookieService.set(this.mftAccessAccounts,JSON.stringify(accounts));
    localStorage.setItem(this.mftAccessAccounts, JSON.stringify(accounts));
  }

  getAccessAccounts(): IAccount[] {
    var accessAccounts: IAccount[] = [];
    //if (this.cookieService.check(this.mftAccessAccounts)){
    //    accessAccounts = <IAccount[]>JSON.parse(this.cookieService.get(this.mftAccessAccounts));            
    //}        
    if (localStorage.getItem(this.mftAccessAccounts) != null && localStorage.getItem(this.mftAccessAccounts).length > 0) {
      accessAccounts = <IAccount[]>JSON.parse(localStorage.getItem(this.mftAccessAccounts));
    }
    return accessAccounts;
  }

  ClearMemoryLeak(userId: string): Observable<null> {
    let callURL = ApiEndPoints.BaseURL + ApiEndPoints.ClearMemoryLeak;
    callURL = callURL.replace("{userId}", userId);
    //let headers: Headers = new Headers({
    //  'Content-Type': 'application/json; charset=utf-8'
    //});
    let options = new RequestOptions({ headers: this.GetHeader() });
    return this.http.get(callURL, options)
      .map((response: Response) => <any>response.json())
      .catch(this.handleError);
  }


  setUserRoles(user: ILoggedUser): void {
    localStorage.setItem(this.mftUserRoles, JSON.stringify(user.grants));
  }

  setUser(user: ILoggedUser): void {
    localStorage.setItem(this.mftUser, JSON.stringify(user));
  }

  getUser(): ILoggedUser {
    var iLoggedUser: ILoggedUser = null;
    if (localStorage.getItem(this.mftUser) != null && localStorage.getItem(this.mftUser).length > 0) {
      iLoggedUser = <ILoggedUser>JSON.parse(localStorage.getItem(this.mftUser));
    }
    return iLoggedUser;
  }

  getUserRoles(): string[] {
    var accessRoles: string[] = [];
    if (localStorage.getItem(this.mftUserRoles) != null && localStorage.getItem(this.mftUserRoles).length > 0) {
      accessRoles = <string[]>JSON.parse(localStorage.getItem(this.mftUserRoles));
    }
    return accessRoles;
  }

  public getSelectedAccessAccounts(): IAccount[] {
    let accesAccounts = this.getAccessAccounts();
    let selectedAccessAccounts = accesAccounts.filter(x => x.selected === true);
    return selectedAccessAccounts;
  }

  public getFirstSelectedAccessAccount(): IAccount {
    return this.getSelectedAccessAccounts()[0];
  }

  checkAccessAccountsAuth(): boolean {
    let accessAccount: boolean = false;
    if (this.getSelectedAccessAccounts().length > 0) {
      accessAccount = true;
    }
    return accessAccount;
  }

  public checkStandardUserEnableForcePasswordChange(): Observable<Response> {
    //let headers: Headers = new Headers({
    //  'Content-Type': 'application/json; charset=utf-8'
    //});
    let options = new RequestOptions({ headers: this.GetAuthHeader() });
    let callURL = ApiEndPoints.BaseURL + ApiEndPoints.StandardUserEnableForcePasswordChange;
    return this.http.get(callURL, options)
      .map((response: Response) => <any>response.json())
      .catch(this.handleError);
  }

  public checkStandardUserEnableUpdateUserProfile(): Observable<Response> {
    //let headers: Headers = new Headers({
    //  'Content-Type': 'application/json; charset=utf-8'
    //});
    let options = new RequestOptions({ headers: this.GetHeader() });
    let callURL = ApiEndPoints.BaseURL + ApiEndPoints.StandardUserEnableUpdateUserProfile;
    return this.http.get(callURL, options)
      .map((response: Response) => <any>response.json())
      .catch(this.handleError);
  }

  //---------------------------------------------------------------------------------------------------------------           

  public getIdentityLoggedUserFromAPI(sub: string): Observable<ILoggedUser> {
    let model = new LoggedUserModel();
    //model.EndPointURL = ApiEndPoints.UserEndPoint;
    model.UserId = sub;
    model.Token = this.getUserToken();
    let body = JSON.stringify(model);
    //let headers: Headers = new Headers({
    //  'Content-Type': 'application/json; charset=utf-8'
    //});      
    let options = new RequestOptions({ headers: this.GetHeader() });
    let callURL = ApiEndPoints.BaseURL + ApiEndPoints.UserEndPointServer;
    return this.http.post(callURL, body, options)
      .map((response: Response) => <any>response.json())
      .do(this.populateLoggerUserInfo)
      .catch(this.handleError);
  }

  public populateLoggerUserInfo(loggeduser: ILoggedUser) {
    //debugger;
    loggeduser.name = loggeduser.firstName + " " + loggeduser.lastName;
    return loggeduser;
  }

  getUserToken() {
    return this.oidcSecurityService.getToken();
  }

  login() {
    console.log('start login');
    this.oidcSecurityService.authorize();
  }

  refreshSession() {
    console.log('start refreshSession');
    this.oidcSecurityService.authorize();
  }

  logout() {
    console.log('start logoff');
    this.oidcSecurityService.logoff();
  }
}



// WEBPACK FOOTER //
// ./src/app/auth.service.ts